const convertNumbThousand = (x?: number): string => {
  if (!x) {
    return "0";
  }
  return x.toLocaleString("en-US");
};
export default convertNumbThousand;

export const formatPrice = (value: number | string): string => {
  let suffix = "";
  let rawValue = value;

  if (typeof value === "string") {
    const match = value.match(/^([\d.]+)(\s*.+)?$/);
    if (match) {
      rawValue = match[1];
      suffix = match[2] ?? "";
    }
  }

  const numValue =
    typeof rawValue === "string" ? parseFloat(rawValue) : (rawValue as number);
  if (isNaN(numValue)) {
    return "0.00";
  }
  const hasDecimals = numValue % 1 !== 0;
  const parts = numValue.toFixed(2).split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];
  const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formatted = hasDecimals ? `${withCommas}.${decimalPart}` : withCommas;
  return `${formatted}${suffix}`;
};
